import { token } from '../../localStorage'
import { BASE_URL } from '../constants'

export const searchChatsByPhone = async ({ talentSearch = '', typeChat = '', phone = '' } = {}) => {
  const params = new URLSearchParams({ talentSearch, typeChat, phone })
  const URL = `${BASE_URL}whatsapp/searchChatsByPhone?${params}`

  const response = await fetch(URL, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: token?.token,
    },
  })

  return response.json()
}

export const getMessagesByPhonePaginated = async ({ page = 0, phone = '', talentId = '' } = {}) => {
  const params = new URLSearchParams({ page, phone, talentId })
  const URL = `${BASE_URL}whatsapp/getMessagesByPhonePaginated?${params}`

  const response = await fetch(URL, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: token?.token,
    },
  })

  return response.json()
}

export const getMessagesByPhone = async ({ phone = '' } = {}) => {
  const params = new URLSearchParams({ phone })
  const URL = `${BASE_URL}whatsapp/getMessagesByPhone?${params}`

  const response = await fetch(URL, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: token?.token,
    },
  })

  return response.json()
}

export const sendMessageByPhone = async ({ phone, message }) => {
  const URL = `${BASE_URL}whatsapp/sendByPhone`

  const response = await fetch(URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: token?.token,
    },
    body: JSON.stringify({ phone, message }),
  })

  return response.json()
}

export const deleteChatByPhone = async ({ phone = '' } = {}) => {
  const params = new URLSearchParams({ phone })
  const URL = `${BASE_URL}whatsapp/deleteChatByPhone?${params}`

  const response = await fetch(URL, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      authorization: token?.token,
    },
  })

  return response.json()
}
